import moment from 'moment'

export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '공사일보 작성일'}, {name: '인원투입 현황(원도급)'}, {name: '주요장비 반입현황(원도급)'}, {name: '인원투입 현황(하도급업체)'}, {name: '주요장비 반입현황(하도급업체)'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 회사명
        case 1: return moment(func.getContent(value).headerDate).format('YYYY-MM-DD') // 공사일보 작성일
        case 2: return func.comma(func.getContent(value).budgetDay1Total) // 인원투입현황(원도급)
        case 3: return func.comma(func.getContent(value).budgetDay2Total) // 주요장비 반입현황(원도급)
        case 4: return func.comma(func.getContent(value).budgetDay3Total) // 인원투입 현황(하도급업체)
        case 5: return func.comma(func.getContent(value).budgetDay4Total) // 주요장비 반입현황(하도급업체)
        case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []
    switch (nav.value.searchType) {
      case '회사명': returnData.push('content$stdInfo.field_name*%[:default_skw]%'); break
      case '공사일보 작성일': returnData.push('content$body.headerDate*%[:default_skw]%'); break
      case '인원투입 현황(원도급)': returnData.push('content$body.budgetDay1Total*%[:default_skw]%'); break
      case '주요장비 반입현황(원도급)': returnData.push('content$body.budgetDay2Total*%[:default_skw]%'); break
      case '인원투입 현황(하도급업체)': returnData.push('content$body.budgetDay3Total*%[:default_skw]%'); break
      case '주요장비 반입현황(하도급업체)': returnData.push('content$body.budgetDay4Total*%[:default_skw]%'); break
    }

    return returnData
  },
}
